import Logo from 'jsx:../img/tandem-logo-horizontal.svg';
import isEmpty from 'lodash.isempty';
import {
	Form,
	Link,
	Navigate,
	useActionData,
	useLocation,
} from 'react-router-dom';
import Alert from '../components/Alert';
import { useAuthStore } from '../components/authStore';

export async function loginAction({ request /*params */ }) {
	const { signIn } = useAuthStore.getState();
	const formData = await request.formData();
	const data = Object.fromEntries(formData);
	try {
		await signIn(data);
		return {};
	} catch (err) {
		return err?.response?.data?.error;
	}
}

const Login = () => {
	const loginError = useActionData();
	const { state } = useLocation();
	if (loginError !== undefined && isEmpty(loginError)) {
		return <Navigate to={state?.from?.pathname || '/'} />;
	}
	return (
		<div className="flex flex-col flex-1 min-h-full px-6 pt-16 lg:px-8">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<div className="w-full h-auto">
					<Logo />
				</div>
				<h1 className="mt-6 leading-9 tracking-tight text-center text-gray-900">
					Sign in to your account
				</h1>
			</div>

			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				<Form className="space-y-6" method="POST" state={state}>
					{loginError?.code === 'LOGIN_FAILED' && (
						<Alert message="Invalid username and/or password, please try again." />
					)}
					{loginError?.code === 'USERNAME_EMAIL_REQUIRED' && (
						<Alert message="Username is required." />
					)}
					{loginError?.code === 'UNKNOWN' && (
						<Alert message="Unable to log in at this time. Please try again later." />
					)}
					<div className="form-control">
						<label htmlFor="email" className="label label-text">
							Email address
						</label>
						<input
							id="email"
							name="email"
							type="email"
							autoComplete="email"
							required
							className="input input-bordered"
						/>
					</div>

					<div className="form-control">
						<label htmlFor="password" className="label label-text">
							Password
						</label>
						<input
							id="password"
							name="password"
							type="password"
							autoComplete="current-password"
							required
							className="input input-bordered"
						/>
					</div>

					<div>
						<button type="submit" className="btn btn-primary btn-block">
							Sign in
						</button>
					</div>

					<div className="text-center">
						<Link to="/forgotPassword" className="link">
							Forgot password?
						</Link>
					</div>

					<div className="grid grid-cols-2">
						<div className="text-center link">
							<a
								href="https://nowintandem.com/terms-of-use/"
								target="_blank"
								rel="noreferrer"
							>
								Terms of Use
							</a>
						</div>
						<div className="text-center link">
							<a
								href="https://nowintandem.com/privacy/"
								target="_blank"
								rel="noreferrer"
							>
								Privacy Policy
							</a>
						</div>
					</div>

					<div className="text-xs text-center">
						&copy; {new Date().getFullYear()} Tandem, Build{' '}
						{process.env.BITBUCKET_BUILD_NUMBER || 'LOCAL'}
					</div>
				</Form>
			</div>
		</div>
	);
};

export default Login;
